/* unplugin-vue-components disabled */import { render } from "./InstallConvey.vue?vue&type=template&id=283d74a8&scoped=true"
import script from "./InstallConvey.vue?vue&type=script&lang=js"
export * from "./InstallConvey.vue?vue&type=script&lang=js"

import "../assets/styles/plan.css?vue&type=style&index=0&id=283d74a8&scoped=true&lang=css&external"
import "./InstallConvey.vue?vue&type=style&index=1&id=283d74a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283d74a8"]])

export default __exports__